import React from 'react';

export interface KeyValueListProps {
    className?: string;
    children: React.ReactNode;
}

export interface KeyValueListRowProps {
    label: React.ReactNode;
    className?: string;
    children: React.ReactNode;
}

const Row: React.FC<KeyValueListRowProps> = ({ label, className = '', children }) => (
    <div
        className={`flex min-h-[52px] w-full items-start border-0 border-b border-solid border-[var(--malachite-card-border)] last:border-b-0 ${className}`}
    >
        <dt className="m-0 w-[200px] shrink-0 p-[16px] text-[13px] leading-[1.6] tracking-[0.13px] text-[var(--malachite-text-secondary)]">
            {label}
        </dt>
        <dd className="m-0 flex min-w-0 flex-1 flex-wrap items-center gap-[6px] py-[16px] pr-[16px] text-[13px] leading-[1.6] tracking-[0.13px] text-[var(--malachite-text-primary)]">
            {children}
        </dd>
    </div>
);

const KeyValueList: React.FC<KeyValueListProps> & { Row: typeof Row } = ({
    className = '',
    children,
}) => (
    <dl
        className={`m-0 flex w-full flex-col overflow-hidden rounded-lg border border-solid border-[var(--malachite-card-border)] bg-[var(--malachite-card-background)] ${className}`}
    >
        {children}
    </dl>
);

KeyValueList.Row = Row;

export default KeyValueList;
export { KeyValueList };
